(function () {
    'use strict';

    /* If Google Analytics is installed calls the trackEvent method
    *
    * @param {string} category Category of the even
    * @param {string} action   Action that triggered the event
    * @param {string} label    Label for the event
    */
    window.gaqTrackEvent = function gaqTrackEvent(category, action, label) {
        /* if (typeof window.gtag !== 'undefined') {
            window.gtag('event', action, {
                'event_category': category,
                'event_label': label
                // 'send_to': 'analytics'
            });
        } */
    };

    /**
     * If Google Analytics is installed calls the trackPageview method.
     *
     * @param {string} url Pageview URL tracking for.
     */
    window.gaqTrackPageview = function gaqTrackPageview(url) {
        if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'page_view', {
                'page_path': url
                // 'send_to': 'analytics'
            });
        }
    };

    /**
     * If Google Analytics is installed calls the social interaction method
     * @param {string} socialNetwork
     * @param {string} socialAction
     * @param {string} socialTarget
     */
    window.gaTrackSocial = function gaTrackSocial(socialNetwork, socialAction, socialTarget) {
        /* if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'social', {
                'event_category': socialNetwork,
                'event_label': socialAction,
                'value': socialTarget
                // 'send_to': 'analytics'
            });
        } */
    };

    /**
     * Tracks select item from listings.
     *
     * @param jsonData
     */
    document.addEventListener('DOMContentLoaded', function (e) {
        let itemsListed = document.querySelectorAll('article[data-role="company-list-item"]');
        if (itemsListed.length <= 0 || typeof window.gtag === 'undefined') return;
        itemsListed.forEach(function (item, position) {
            item.addEventListener('click', function (event) {
                let nodeTarget = event.target,
                    itemNode = event.target.parentNode;
                while (itemNode !== null && itemNode.nodeName.toLowerCase() !== 'article') {
                    if (typeof itemNode.parentNode !== 'undefined') {
                        itemNode = itemNode.parentNode;
                    } else {
                        itemNode = null;
                    }
                }

                if (itemNode === null) return;

                // Generate item
                window.tmhAn.leadInteraction.selected_item_id = parseInt(this.getAttribute('id'));
                window.tmhAn.leadInteraction.selected_item_position_list =
                    ((window.tmhAn.listingProperties.listPage - 1) * 15) + position + 1;
                let itemGa = {
                    'id': this.getAttribute('id'),
                    'name': this.getAttribute('data-name'),
                    'item_name': this.getAttribute('data-name'),
                    'item_id': this.getAttribute('id'),
                    'item_list_name': this.getAttribute('data-list-title'),
                    'item_list_id': this.getAttribute('data-list-id'),
                    'item_position': window.tmhAn.leadInteraction.selected_item_position_list,
                    'quantity': 1,
                },
                itemDefaultGA = {
                    event_category: 'engagement',
                    list_name: this.getAttribute('data-list-title'),
                    list_id: this.getAttribute('data-list-id'),
                    com_id: this.getAttribute('id'),
                    com_name: this.getAttribute('data-name'),
                    com_price: this.getAttribute('data-price'),
                    com_currency: this.getAttribute('data-currency'),
                    com_position: window.tmhAn.leadInteraction.selected_item_position_list
                };

                // Check other attributes
                if (this.getAttribute('data-price') !== null) {
                    itemGa.price = this.getAttribute('data-price');
                    itemGa.currency = this.getAttribute('data-currency');
                }

                // Check for request button
                if (nodeTarget.nodeName.toLowerCase() === 'button' && nodeTarget.getAttribute('data-role') === 'request') {
                    itemDefaultGA.event_label = 'listrequest_' + this.getAttribute('data-list-id');
                    window.gtag('event', 'list_request', itemDefaultGA);

                    return;
                }

                // Check for agenda ctas
                if (hasParent(nodeTarget, 'agenda')) {

                    if (hasParent(nodeTarget, 'ie-listings-agenda-btn')
                        && nodeTarget.classList.contains('cta')
                        && nodeTarget.nodeName.toLowerCase() === 'a')
                    {
                        itemDefaultGA.event_label = 'listagendamore_' + this.getAttribute('data-list-id');
                        itemDefaultGA = Object.assign(itemDefaultGA, generateAgendaVisibleTreeElements(nodeTarget));
                        window.gtag('event', 'list_agenda_more', itemDefaultGA);

                        return;
                    }

                    if (hasParent(nodeTarget, 'ie-listings-agenda-select')
                        && nodeTarget.classList.contains('ie-listings-agenda-select-hour')
                        && nodeTarget.nodeName.toLowerCase() === 'span')
                    {
                        let helperNode = nodeTarget.parentNode.querySelector('.ie-listings-agenda-select-lbl');

                        itemDefaultGA.event_label = 'list_agenda_selected_' + this.getAttribute('data-list-id');
                        itemDefaultGA.agenda_day = helperNode !== null ? helperNode.innerText : 'undefined';
                        itemDefaultGA.agenda_hour = nodeTarget.innerText;
                        itemDefaultGA = Object.assign(itemDefaultGA, generateAgendaVisibleTreeElements(nodeTarget));
                        window.gtag('event', 'list_agenda_selected', itemDefaultGA);

                        return;
                    }
                }

                // Check for appointment button
                if (nodeTarget.nodeName.toLowerCase() === 'button' && nodeTarget.getAttribute('data-role') === 'appointment') {
                    itemDefaultGA.event_label = 'listappointment_' + this.getAttribute('data-list-id');
                    window.gtag('event', 'list_appointment', itemDefaultGA);

                    return;
                }

                // Send
                window.gtag('event', 'select_item', {
                    'event_category': 'engagement',
                    'event_label': 'selectitem_' + this.getAttribute('data-list-id'),
                    'items': [itemGa],
                    'item_list_name': this.getAttribute('data-list-title'),
                    'item_list_id': this.getAttribute('data-list-id')
                });
            });
        });
    }, false);

    /**
     * Tracks noresults button.
     *
     * @param jsonData
     */
    document.addEventListener('DOMContentLoaded', function (e) {
        let noresultscta = document.getElementById('noresults-cta');

        if (noresultscta !== null) {
            noresultscta.addEventListener('click', function (event) {
                if (typeof window.gtag !== 'undefined') {
                    window.gtag('event', 'click', {
                        event_category: 'engagement',
                        event_label: 'noresults',
                        name: 'noresults-cta'
                    });
                }
            });
        }

    }, false);

    /**
     * Send show request modal.
     *
     * @param {Number} comID
     */
     window.gaTrackListRequestOpenModal = (comID) => {
        if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'list_request_form_show', {
                event_category: 'engagement',
                event_label: 'list_request_form_show_' + window.tmhAn.listingProperties.listId + '_com#' + comID,
                type: 'request',
                list: window.tmhAn.listingProperties.listId,
                company: comID
            });
        }
    };

    /**
     * Send close request modal.
     *
     * @param {Number} comID
     */
     window.gaTrackListRequestCloseModal = (comID) => {
        if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'list_request_form_close', {
                event_category: 'engagement',
                event_label: 'list_request_form_close_' + window.tmhAn.listingProperties.listId + '_com#' + comID,
                type: 'request',
                list: window.tmhAn.listingProperties.listId,
                company: comID
            });
        }
    };

    /**
     * Send form invalid input on request modal.
     *
     * @param {Number} comID
     * @param {String} errorsMsg
     * @param {String} invalidFields
     */
     window.gaTrackListRequestFormInvalidInputs = (comID, errorsMsg, invalidFields) => {
        if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'list_request_form_invalid_input', {
                event_category: 'engagement',
                event_label: 'list_request_form_invalid_input_' + window.tmhAn.listingProperties.listId + '_com#' + comID + '_error#' + errorsMsg,
                type: 'request',
                list: window.tmhAn.listingProperties.listId,
                company: comID,
                fields: invalidFields
            });
        }
    };

    /**
     * Send form request modal.
     *
     * @param {Number} comID
     */
     window.gaTrackListRequestFormSend = (comID) => {
        if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'list_request_form_send', {
                event_category: 'engagement',
                event_label: 'list_request_form_send_' + window.tmhAn.listingProperties.listId + '_com#' + comID,
                type: 'request',
                list: window.tmhAn.listingProperties.listId,
                company: comID
            });
        }
    };

    /**
     * Tracks conversion with given json
     *
     * @param {string} jsonData
     * @param {function} gtagCallback
     */
    window.gaTrackTransaction = function gaTrackTransaction(jsonData, gtagCallback) {
        var data = jsonData,
            items = [],
            listElements = document.querySelectorAll('main.list .list-items > article'),
            listPage = 0,
            itemIndex = 0,
            itemListID = '',
            itemListName = '',
            transactionRelID = 0;
        if (typeof window.gtag !== 'undefined') {
            if (data.transactionItems.length > 0) {
                if (data.transactionItems.length > 1 && data.leadType === 'Multi') {
                    data.transactionItems.shift();
                }
                data.transactionItems.forEach(function (item) {

                    // Load data for desired company
                    if (listElements.length > 0) {
                        listElements.forEach(function(e, i){
                            listPage = parseInt(e.parentNode.getAttribute('data-page'));
                            if (parseInt(e.getAttribute('data-company-id')) === parseInt(item.sku)) {
                                itemIndex = i;
                                if (listPage > 1) {
                                    itemIndex = ((listPage - 1) * 15) + itemIndex;
                                }
                                itemListID = e.getAttribute('data-list-id');
                                itemListName = e.getAttribute('data-list-title');
                            }
                        });
                    }

                    items.push({
                        'id': item.sku,
                        'name': item.productName,
                        'brand': item.brand,
                        'category': item.category,
                        'variant': item.clientType,
                        'quantity': 1,
                        'price': item.price,
                        'item_id': item.sku,
                        'item_name': item.productName,
                        'item_brand': item.brand,
                        'item_category': item.category,
                        'item_category2': item.cat_location,
                        'item_category3': item.cat_market,
                        'item_category4': item.cat_transaction,
                        'item_category5': item.leadType,
                        'item_variant': item.clientType,
                        'location_id': item.location_id,
                        'item_list_name': itemListName,
                        'item_list_id': itemListID,
                        'item_req_headquarter': item.cd_req_headquarter,
                        'index': itemIndex
                    });

                    transactionRelID = item.transactionRelId;
                });
            }

            var purchaseData = {
                'event_category': 'ecommerce',
                'event_label': 'purchase_user_request',
                // 'send_to': 'analytics',
                'transaction_type': data.type, // appointment or request
                'client_type': data.clientType, // Refer to company
                'lead_type': data.leadType, // mono request - multi request
                'cd_user_id': data.cd_user_id,
                'cd_user_type': data.cd_user_type,
                'cd_user_logged': data.cd_user_logged,
                'cd_user_lead_timestamp': data.cd_lead_timestamp,
                'cd_user_lead_com_id': data.cd_lead_com_id,
                'cd_user_lead_com_name': '[' + data.cd_lead_com_name + ']_' + data.cd_lead_com_id,
                'cm_lead_unique_transact': data.cd_user_unique_reqs,
                'cd_lead_serv_type': '[' + window.tmhAn.listingProperties.serTitle + ']_'
                    + window.tmhAn.listingProperties.serId,
                'cd_lead_pop_type': '[' + window.tmhAn.listingProperties.zoneTitle + ']_'
                + window.tmhAn.listingProperties.zoneId,
                'cd_lead_popservice_type':
                    '[' + window.tmhAn.listingProperties.serTitle + ']_' + window.tmhAn.listingProperties.serId +
                    '#[' + window.tmhAn.listingProperties.zoneTitle + ']_' + window.tmhAn.listingProperties.zoneId
                ,
                'cd_lead_therapy_type': data.cat_market,
                'cd_page_type': 'list_' + window.tmhAn.listingProperties.listType,
                'cd_lead_page_path': window.tmhAn.listingProperties.listUrl(),
                'cd_lead_pro_position': window.tmhAn.leadInteraction.selected_item_position_list,
                'cd_req_headquarter': data.cd_req_headquarter,
                'cd_transaction_id': data.transactionId,
                'cds_lead_popservice_type':
                    '[' + window.tmhAn.listingProperties.serTitle + ']_' + window.tmhAn.listingProperties.serId +
                    '#[' + window.tmhAn.listingProperties.zoneTitle + ']_' + window.tmhAn.listingProperties.zoneId
                ,
                'cds_page_type': 'list_' + window.tmhAn.listingProperties.listType,
                'cds_lead_page_path': window.tmhAn.listingProperties.listUrl(),
                'cds_transaction_id': data.transactionId,
                'value': data.price,
                'currency': data.currency,
                'transaction_id': data.transactionId,
                'transactionRelId': transactionRelID,
                'shipping': 0,
                'items': items
            };

            if (typeof gtagCallback === 'function') {
                purchaseData.event_callback = gtagCallback;
            }
            window.gtag('event', 'purchase', purchaseData);
        }
    };

    /**
     * Adwords pixel conversion function
     *
     * @param {string} adwordsId
     * @param {string} adwordsConversionLabel
     * @param {float} price
     */
    window.gaTrackAdwordsConversion = function gaTrackAdwordsConversion(adwordsId, adwordsConversionLabel, data) {
        var conversionLabel = [adwordsId, '/', adwordsConversionLabel];
        if (typeof window.gtag !== 'undefined') {

            // Add improved conversions
            window.enhanced_conversion_data = {
                "email": data.leadProperties.email,
                "phone_number": data.leadProperties.phone
            };
            window.gtag('set', 'user_data', {
                "email": data.leadProperties.email,
                "phone_number": data.leadProperties.phone
            });

            window.gtag('event', 'conversion', {
                'send_to': conversionLabel.join(''),
                'value': data.price,
                'currency': data.currency,
                'transaction_id': data.transactionId
            });
        }
    };

    /**
     * Tracks conversion with given json
     *
     * @param {string} jsonData
     */
    window.bingTrackTransaction = function bingTrackTransaction(jsonData) {
        if (typeof window.uetq !== 'undefined') {
            window.uetq.push('event', 'Purchase', {
                'event_category': jsonData.type,
                'event_label': 'Transaction',
                'event_value': 1
            });
        }
    };

    /**
     * Tracks conversion with given json data
     *
     * @param {string} jsonData
     */
     window.fbTrackTransaction = function fbTrackTransaction(jsonData) {
        var data = jsonData,
            items = [];
        if (typeof window.fbq !== 'undefined') {
            if (data.transactionItems.length > 0) {
                if (data.transactionItems.length > 1 && data.leadType === 'Multi') {
                    data.transactionItems.shift();
                }
                data.transactionItems.forEach(function (item) {
                    items.push({
                        'id': item.sku,
                        'name': item.productName,
                        'quantity': 1,
                        'price': item.price,
                        'brand': item.brand,
                        'category': item.category,
                        'variant': item.clientType,
                        'item_name': item.productName,
                        'item_brand': item.brand,
                        'item_category2': item.cat_location,
                        'item_category3': item.cat_market,
                        'item_category4': item.cat_transaction,
                        'item_category5': item.leadType,
                        'location_id': item.location_id
                    });
                });
            }
            window.fbq('track', 'Purchase', {
                'value': data.price,
                'currency': data.currency,
                'content_type': 'product',
                'content_ids': [data.transactionId],
                'num_items': 1,
                'contents': items,
                'lead_type': data.leadType // mono request - multi request
            });
        }
    };

    /**
     * Fires all transaction pixels
     *
     * @param {object} transactionData
     * @param {object} trackingData
     * @param {function} gtagCallback
     */
    window.trackAllTransactions = function trackAllTransactions(transactionData, trackingData, gtagCallback) {
        if (typeof transactionData.disabledCom === 'boolean' && transactionData.disabledCom) {
            if (typeof gtagCallback === 'function') {
                gtagCallback();
            }
            return;
        }
        window.bingTrackTransaction(transactionData);
        window.fbTrackTransaction(transactionData);
        if (
            transactionData.appointmentRequest &&
            typeof trackingData.adwordsAppointmentConversionLabel !== 'undefined'
        ) {
            window.gaTrackAdwordsConversion(
                trackingData.adwordsId,
                trackingData.adwordsAppointmentConversionLabel,
                transactionData
            );
        } else if (typeof trackingData.adwordsRequestConversionLabel !== 'undefined') {
            window.gaTrackAdwordsConversion(
                trackingData.adwordsId,
                trackingData.adwordsRequestConversionLabel,
                transactionData
            );
        }
        window.gaTrackTransaction(transactionData, gtagCallback);
    };

    /*********************************************************
     * HELPER METHODS                                        *
     *********************************************************/

    /**
     * Check if parent nodes has the provided class name.
     *
     * @param {NodeElement} element
     * @param {String} className
     * @returns {Boolean}
     */
    const hasParent = (element, className) => {
        if (!element.parentNode) {
            return false;
        }

        if (element.classList.contains(className)) {
            return true;
        }

        return hasParent(element.parentNode, className);
    };

    /**
     * Generate the agenda tree array data.
     *
     * @param {NodeElement} element
     * @returns {Array}
     */
    const generateAgendaVisibleTreeElements = (element) => {
        let elementsLabels = element.parentNode.parentNode.querySelectorAll(
            '.ie-listings-agenda-select > .ie-listings-agenda-select-lbl'
            ),
            elementsTimes = [],
            elementsTree = {};

        if (elementsLabels !== null && elementsLabels.length > 0) {
            elementsLabels.forEach((e,i) => {
                elementsTimes = e.parentNode.querySelectorAll('.ie-listings-agenda-select-hour')
                elementsTimes.forEach((eT, iT) => {
                    elementsTree['agenda_visible_items_day_' + i] = e.innerText;
                    elementsTree['agenda_visible_items_hour_' + i + '_' + iT] = eT.innerText;
                });
            });
        }

        return elementsTree;
    };

}());
